<div [class]="titleClasses">
    <h5>How to set up VisitorIntel:</h5>
    <p>To start tracking visitors simply copy and paste this Javascript on each page of your website.</p>
</div>
<ng-cotainer *ngIf="(featureFlagsEnum.VisitorIntelRedux | isFeatureFlagEnabled | async); else bomboraScriptTpl">
	<section class="result-loader" *ngIf="isLoading$ | async">
		<div class="mb-2">
			<mat-spinner></mat-spinner>
		</div>
	</section>
	<div class="flex-none w-full relative px-2" *ngIf="siScript$ | async as script">
		<mat-form-field appearance="fill" class="mb-2 w-full">
			<mat-label>Script</mat-label>
			<textarea matInput #tag [value]="script" readonly [rows]="textareaRows" cols="80" class="resize-none"></textarea>
		</mat-form-field>
		<button matButton="outlined" type="button" class="btn-copy" [ngxClipboard]="tag" (cbOnSuccess)="isCopiedTag = true">{{ isCopiedTag ? 'Copied' : 'Copy' }}</button>
	</div>
</ng-cotainer>

<ng-template #bomboraScriptTpl>
	<div class="flex-none w-full relative px-2" *ngIf="uuid$ | async as uuid">
		<mat-form-field appearance="fill" class="mb-2 w-full">
			<mat-label>Script</mat-label>
			<textarea matInput #tag readonly [rows]="textareaRows" cols="80" class="resize-none">
				<script>
					(function (w, d, t) {
						_ml = w._ml || {};
						_ml.eid = '81430';
						_ml.cid = '{{uuid}}';
						var s, cd, tag; s = d.getElementsByTagName(t)[0]; cd = new Date();
						tag = d.createElement(t); tag.async = 1;
						tag.src = 'https://ml314.com/tag.aspx?' + cd.getDate() + cd.getMonth();
						s.parentNode.insertBefore(tag, s);
					})(window, document, 'script');
				</script>
			</textarea>
		</mat-form-field>
		<button matButton="outlined" type="button" class="btn-copy" [ngxClipboard]="tag" (cbOnSuccess)="isCopiedTag = true">{{ isCopiedTag ? 'Copied' : 'Copy' }}</button>
	</div>
</ng-template>
